import { AdminMarkingLocationsListLoading } from '@/views/admin-marking-locations/home/admin-marking-locations-list.loading';

export default AdminMarkingLocationsListLoading;
